/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legaroo_Landing_Feature_3Inputs */

const en_service_legaroo_landing_feature_3 = /** @type {(inputs: Service_Legaroo_Landing_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation help`)
};

const fr_service_legaroo_landing_feature_3 = /** @type {(inputs: Service_Legaroo_Landing_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aide à la documentation`)
};

/**
* | output |
* | --- |
* | "Documentation help" |
*
* @param {Service_Legaroo_Landing_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legaroo_landing_feature_3 = /** @type {((inputs?: Service_Legaroo_Landing_Feature_3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legaroo_Landing_Feature_3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legaroo_landing_feature_3(inputs)
	return fr_service_legaroo_landing_feature_3(inputs)
});